<template>
  <v-dialog
    v-model="resourcePreviewPopup"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <v-card>
      <v-toolbar dark color="primary">
        <v-btn icon dark @click="resourcePreviewPopup = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>Preview</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn dark text @click="resourcePreviewPopup = false">
            Save
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <TakeAssessment class="pa-4" style="background:white" />
    </v-card>
  </v-dialog>
</template>

<script>
  import TakeAssessment from "../../../Parents/Auth/components/TakeAssessment";
  export default {
    name: "PreviewDialog",
    components: {
      TakeAssessment,
    },
    data() {
      return {};
    },
    created() {},
    computed: {
      resourcePreviewPopup: {
        get() {
          return this.$store.state.resourcePreviewPopup;
        },
        set(value) {
          this.$store.state.resourcePreviewPopup = value;
        },
      },
    },
    watch: {},
    methods: {},
    mounted() {},
  };
</script>

<style scoped></style>
